import { Usuario } from '@/models'

export function cpfEhObrigatorioParaUsuario(
	usuario: Pick<Usuario, 'vendedor'>,
	novo: boolean,
): boolean {
	return !usuario.vendedor || novo
}

export function campoDeCpfEstaBloqueado(
	usuario: Pick<Usuario, 'vendedor'>,
	novo: boolean,
	cpfJaCadastrado: boolean,
): boolean {
	return !novo && usuario.vendedor && cpfJaCadastrado
}

export function validarCamposObrigatoriosDoVendedor(
	usuario: Pick<Usuario, 'vendedor' | 'cpf' | 'telefones'>,
	novo: boolean,
): string | null {
	if (!novo || !usuario.vendedor) return null
	if (usuario.cpf === null || usuario.cpf === '') {
		return 'Obrigatório informar CPF do vendedor'
	}
	if (usuario.telefones.filter(t => t).length === 0) {
		return 'Obrigatório informar ao menos um telefone para o vendedor'
	}
	return null
}

export function criarUsuario(): Usuario {
	return {
		id: '',
		email: null,
		nome: '',
		login: '',
		cpf: null,
		ativo: true,
		perfil: {
			id: '',
			nome: '',
			permissoes: [],
			gruposEconomicos: [],
			percentualMaximoDesconto: 0,
			tempoParaLogoff: '',
			percentualMaximoDescontoPorItem: 0,
			tempoLimiteDeInatividade: '',
			telaInicial: '',
			limiteCustoMensalIA: 0,
			perfilInterno: false,
		},
		tags: [],
		lojas: [],
		avatar: '',
		senha: '',
		pdvs: [],
		telefones: [],
		vendedor: false,
		criaFaq: false,
		gruposEconomicos: [],
		autoLoginAoAbrirCaixa: false,
		codigoExterno: undefined,
		isPrimeiroAcesso: false,
		representante: false,
		usuarioTecnico: false,
	}
}
